import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { provideCore } from '@core/core';

import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { timeoutInterceptor } from '@core/interceptors/timeout.interceptor';      // functional
import { httpErrorInterceptor } from '@core/interceptors/error.interceptor';
import { auth403OnlyInterceptor } from '@core/interceptors/auth-403-only.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideCore({ routes }),

    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    provideHttpClient(
      withInterceptors([
        timeoutInterceptor,       
        httpErrorInterceptor,     
        auth403OnlyInterceptor,    
      ])
    ),
  ],
};